/**
 * Public API errors — keys match backend `publicApiErrorCodes.ts` string values.
 */
export const COMMON_UI_I18N_PART2_SLICE_D = {
	publicApiErrors: {
		PUBLIC_EMAIL_AUTH_EMAIL_REQUIRED: "Email requis.",
		PUBLIC_ANCHOR_VERIFY_HASH_REQUIRED: "Le hash du document est requis.",
		PUBLIC_ANCHOR_VERIFY_INVALID_HASH_FORMAT: "Format de hash invalide. Attendu : 64 caractères hexadécimaux (SHA256).",
		PUBLIC_ANCHOR_VERIFY_FILE_TOO_LARGE: "Le fichier est trop volumineux (max 100 Mo).",
		PUBLIC_ANCHOR_VERIFY_NO_FILE: "Aucun fichier fourni.",
		PUBLIC_ANCHORS_CALLBACK_MISSING_DOCUMENT_FIELDS: "Champs requis : transaction_id, status et document_uid.",
		PUBLIC_ANCHORS_CALLBACK_MISSING_FOLDER_FIELDS: "Champs requis : transaction_id, status et folder_uid.",
		PUBLIC_ANCHORS_CALLBACK_INVALID_STATUS: "Valeur de statut invalide.",
		PUBLIC_ANCHORS_CALLBACK_UNAUTHORIZED: "Non autorisé.",
		PUBLIC_INCIDENT_REPORT_MESSAGE_REQUIRED: "Le message est requis.",
	},
} as const;
